import React from "react";

const InterestListContext = React.createContext({});

export default InterestListContext;
